"use strict";

var _Button;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { SuburbSelect } from '@autoguru/components';
import { Button } from '@autoguru/overdrive';
import { forwardRef, useState } from 'react';
import { RETAIL_API } from '@autoguru/global-configs';
import { FleetMakeSelect } from '../../components/FleetMakeSelect/FleetMakeSelect';
import { FleetModelSelect } from '../../components/FleetModelSelect/FleetModelSelect';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// biome-ignore lint/suspicious/noExplicitAny: migration quick fix. To be fixed when code is touched
const HomeQuoteLauncherForm = /*#__PURE__*/forwardRef(({
  className: _className = '',
  make,
  model,
  location,
  suburbChanged,
  makeChanged,
  modelChanged,
  handleSubmit
}, targetRef) => {
  const [validateForm, setValidateForm] = useState(false);
  const onKeyPress = event => {
    if (event && event.key === 'Enter') {
      onSubmit(event);
    }
  };
  const onSubmit = event => {
    setValidateForm(true);
    handleSubmit(event);
  };
  return /*#__PURE__*/_jsxs("form", {
    ref: targetRef,
    noValidate: true,
    className: _className,
    onKeyPress: onKeyPress,
    onSubmit: onSubmit,
    children: [/*#__PURE__*/_jsx(FleetMakeSelect, {
      isTouched: validateForm,
      isValid: Boolean(make),
      valueChanged: makeChanged,
      make: make
    }), /*#__PURE__*/_jsx(FleetModelSelect, {
      isTouched: validateForm,
      isValid: Boolean(model),
      model: model,
      makeId: make ? make.id : null,
      valueChanged: modelChanged
    }), /*#__PURE__*/_jsx(SuburbSelect, {
      isTouched: validateForm,
      isValid: Boolean(location),
      value: location,
      apiUrl: RETAIL_API,
      onChange: suburbChanged
    }), _Button || (_Button = /*#__PURE__*/_jsx(Button, {
      as: "button",
      type: "submit",
      variant: "primary",
      size: "medium",
      children: "Let's go!"
    }))]
  });
});
export default HomeQuoteLauncherForm;